const NAMESPACE = 'app-management' as const;

const CLIPBOARD_COPIED_TIMEOUT_MS = 5000 as const;
const CLIPBOARD_COPIED_TOOLTIP_TEXT = 'Copied!' as const;
const CLIPBOARD_HOVER_TOOLTIP_TEXT = 'Copy to clipboard' as const;

const DAYS_BEFORE_SHOWING_DELETION_LABEL_THRESHOLD = 6 as const;

const TABLE_PAGE_SIZES = [25, 50, 75, 100] as const;

const ALLOWED_UPLOAD_FILE_TYPES = ['.apk', '.ipa', '.zip', '.aab'] as const;
const ALLOWED_UPLOAD_FILE_TYPES_STRING = ALLOWED_UPLOAD_FILE_TYPES.join(', ');

export default {
  ALLOWED_UPLOAD_FILE_TYPES,
  ALLOWED_UPLOAD_FILE_TYPES_STRING,
  CLIPBOARD_COPIED_TIMEOUT_MS,
  CLIPBOARD_COPIED_TOOLTIP_TEXT,
  CLIPBOARD_HOVER_TOOLTIP_TEXT,
  DAYS_BEFORE_SHOWING_DELETION_LABEL_THRESHOLD,
  NAMESPACE,
  TABLE_PAGE_SIZES,
};
